import React, { useEffect, useRef } from "react";

import { addStyle } from "@helpers/helpers";

type PropsType = {
  children: React.ReactNode;
  animation?: boolean;
};

function EmptyAnimationDiv({ children, animation }: PropsType) {
  const divCover = useRef<HTMLDivElement>(null);
  const div = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (animation)
      addStyle(divCover.current, `height: ${div.current?.clientHeight}px`);
  }, [animation, children]);

  return (
    <div
      className='transition-height delay-0 duration-200 ease-linear'
      ref={divCover}
    >
      <div ref={div}>{children}</div>
    </div>
  );
}

export default EmptyAnimationDiv;
